import { ActionFunction, redirect } from 'react-router-dom';
// Sentry
import * as Sentry from '@sentry/react';

// Steps
import { passData } from './ActionUtils/passData';
import { saveData } from './ActionUtils/saveData';
import { showErrorToast, showSuccessToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';
import { DraftOwnerMismatchError } from '../../../../../utils/draftOwnership';

function isOfflineQueuedError(err: unknown): boolean {
  const e = err as {
    offlineQueued?: boolean;
    message?: string;
    networkError?: { offlineQueued?: boolean };
  };
  return (
    e?.offlineQueued === true ||
    e?.networkError?.offlineQueued === true ||
    (e?.message ?? '').includes('Mutation queued for offline sync')
  );
}

export const ActionNewWorkOrderDuplicateSummary: ActionFunction = async ({
  request,
}) => {
  const formData = await request.formData();
  const intent = formData.get('intent');
  if (intent === 'pass-data') {
    try {
      return passData(formData);
    } catch (err) {
      Sentry.captureException(err);
      console.log('Error:', err);
    }
  }
  if (intent === 'save-data') {
    try {
      const id = formData.get('id');
      return await saveData(id);
    } catch (err) {
      // Bloque C-7.5: si la mutation (SAVE_GENERIC_ORDER o SAVE_CAMPAIGN según
      // rama) se encoló offline, redirigimos a la lista correspondiente. El
      // sync individual de Apollo OfflineQueueLink replay-ea la mutation al
      // reconectar.
      if (isOfflineQueuedError(err)) {
        showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
        window.dispatchEvent(new CustomEvent('offline-workorder-queued'));
        return redirect('/work-orders');
      }
      Sentry.captureException(err);
      console.log('> WorkOrderSummary - error creating:', err);
      // La barrera del dueño no escribe nada; sin aviso el usuario pulsaría
      // «Guardar» y no pasaría nada.
      if (err instanceof DraftOwnerMismatchError) {
        showErrorToast(i18n.t('toasts:error.generic'));
      }
    }
  }
  return null;
};
